import { render, staticRenderFns } from "./ComplaintsSampleTable.vue?vue&type=template&id=4fc5b3b6&scoped=true"
import script from "./ComplaintsSampleTable.vue?vue&type=script&lang=js"
export * from "./ComplaintsSampleTable.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsSampleTable.vue?vue&type=style&index=0&id=4fc5b3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc5b3b6",
  null
  
)

export default component.exports